import { axiosInstance } from '../App';

export const getExchangeRates = () => {
  return axiosInstance.get(`/nbs/exchange-rates`).then(response => response.data);
};
